import { useAuth0 } from '@auth0/auth0-react'
import {
  AppBar,
  Box,
  BoxProps,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery
} from '@mui/material'
import { Logout, Menu as MenuIcon } from '@mui/icons-material'
import LogoMzc from './images/logo_miraiz-connect.png'
import { useLocation, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { includes } from 'lodash/fp'
import { signOut } from 'aws-amplify/auth'

const CONTACRT_URL =
  'https://terashite.zendesk.com/hc/ja/sections/4497724005273-%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B'

const HamburgerMenu = (props: { logout: Function }) => {
  const { logout } = props
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const menuItems = [
    { label: 'ご契約の確認・解約', action: () => navigate('/user') },
    {
      label: 'お客さま情報の確認・変更',
      action: () => navigate('/user/info')
    },
    { label: 'お支払履歴', action: () => navigate('/user/paymentLog') },
    {
      label: 'お問い合わせ',
      action: () => window.open(CONTACRT_URL, '_blank', 'noopener,noreferrer')
    },
    { label: 'ログアウト', action: () => logout() }
  ]

  return (
    <div>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={handleMenuOpen}>
        <MenuIcon color="primary" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}>
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              item.action()
              handleMenuClose()
            }}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export const Header = (props: BoxProps) => {
  const { logout } = useAuth0()
  const logoutUrl = window.location.origin + '/logout'

  const onLogoutButtonClick = () => {
    logout({ logoutParams: { returnTo: logoutUrl } })
    signOut()
  }

  const location = useLocation()
  const isSmall = useMediaQuery('(max-width:600px)')
  return (
    <Box {...props}>
      <AppBar
        component="header"
        position="relative"
        elevation={1}
        sx={{
          borderWidth: 0,
          height: 64,
          backgroundColor: 'transparent',
          margin: 0
        }}>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignContent={'center'}>
          <Box display={'flex'}>
            <Box
              component="img"
              sx={{
                height: 48
              }}
              alt="Logo"
              src="/assets/logo_terashite.png"
              position={'relative'}
            />
          </Box>
          <Box display={'flex'} justifyContent={'end'}>
            {includes(location.pathname)(['/logout']) ? (
              <Box />
            ) : includes(location.pathname)([
                '/user',
                '/user/',
                '/user/info',
                '/user/edit',
                '/user/paymentLog',
                '/user/paymentEdit'
              ]) ? (
              <HamburgerMenu logout={onLogoutButtonClick} />
            ) : (
              <IconButton
                color="primary"
                sx={{ fontSize: 12 }}
                onClick={onLogoutButtonClick}>
                <Logout />
                ログアウト
              </IconButton>
            )}
            {!isSmall ? (
              <Box
                component="img"
                sx={{ height: 64 }}
                alt="EndLogo"
                src={LogoMzc}
                alignSelf={'center'}
                position={'relative'}
                justifyContent={'end'}></Box>
            ) : (
              <></>
            )}
          </Box>
        </Box>
      </AppBar>
    </Box>
  )
}